import { render, staticRenderFns } from "./productCertification.vue?vue&type=template&id=6e3e7f2e&scoped=true&"
import script from "./productCertification.vue?vue&type=script&lang=js&"
export * from "./productCertification.vue?vue&type=script&lang=js&"
import style0 from "./productCertification.vue?vue&type=style&index=0&id=6e3e7f2e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e3e7f2e",
  null
  
)

export default component.exports